import { render, staticRenderFns } from "./LaurusHomes.vue?vue&type=template&id=4ea110f7"
import script from "./LaurusHomes.vue?vue&type=script&lang=js"
export * from "./LaurusHomes.vue?vue&type=script&lang=js"
import style0 from "./LaurusHomes.vue?vue&type=style&index=0&id=4ea110f7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports